import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Button from '../button/button';

import { Dispensary } from '../../models/strapi/stateLandingPageQuery';

import * as styles from './locationCard.module.scss';

interface Props {
    dispensary: Dispensary;
    usingMouse: boolean;
}

export function LocationCard({ dispensary, usingMouse }: Props) {
    const pu = dispensary.phoneNumberUnformatted;
    const phoneFormatted = `(${pu.slice(0, 3)}) ${pu.slice(3, 6)}-${pu.slice(6, 11)}`;
    return (
        <div className={styles.cardContainer}>
            <p className={`sh1 ${styles.cardTitle}`}>{dispensary.name}</p>
            <a className={styles.gmapLink} href={dispensary.gmapLink}>
                <div className='body1'>
                    {dispensary.address.addressLine1}{' '}
                    {dispensary.address.addressLine2 ? dispensary.address.addressLine2 : ''}
                </div>
                <div className='body1'>
                    {dispensary.address.city}, {dispensary.address.state}{' '}
                    {dispensary.address.zipcode}
                </div>
            </a>
            <div className={`body1 ${styles.phone}`}>{phoneFormatted}</div>
            <div className={styles.hoursContainer}>
                {dispensary.dispensary_hours
                    ? dispensary.dispensary_hours.hoursOfOperation.map((hour, i: number) => {
                          return (
                              <Row key={i} className='g-0'>
                                  <Col className='body1' xs={5}>
                                      {hour.title}:
                                  </Col>
                                  <Col className='body1'>{hour.time}</Col>
                              </Row>
                          );
                      })
                    : null}
            </div>
            {dispensary.storefronts && dispensary.storefronts.length === 1 ? (
                <div className={styles.shopButton}>
                    <Button
                        label={`Shop ${dispensary.name}`}
                        block='full'
                        variant='primary'
                        size='lg'
                        linkHref={
                            dispensary.storefronts[0].platform === 'redirect'
                                ? dispensary.storefronts[0].frameData.url
                                : `/shop/${dispensary.storefronts[0].slug}`
                        }
                        usingMouse={usingMouse}
                    />
                </div>
            ) : null}
        </div>
    );
}
